<template>
	<div>
		<b-overlay
			v-if="loading"
			:show="loading"
			rounded
			opacity="1"
			spinner-small
			spinner-variant="primary"
		>
			<div :style="`min-height: ${height}px;`">
			</div>
		</b-overlay>
		<template v-if="!loading">
			<StatisticGraph
				:chart-options="chartOptions"
				:chart-data="chartData"
				:height="height"
			></StatisticGraph>
		</template>
	</div>
</template>  
<script>
	import { toShortMillions } from "@/mixins/textFilters";
	import StatisticGraph from '@components/charts/StatisticGraph';
	import { API_GET_MOTIVATION_LOAD_RESULTS_FOR_CHARTS } from '@/constants';

	export default {
	components: {
		StatisticGraph
	},
	mixins: [
		toShortMillions
	],	
	props: {
		selectedPeriod: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			loading: false,
			chartData: null,
			chartOptions: {
				scales: {
					yAxes: [
						{
							id: 'y-axis-1',
							type: 'linear',
							position: 'left',
							ticks: {
								beginAtZero: true,
								// Formatter for values in millions
								callback: function(value) {
									return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
								}
							},
							scaleLabel: {
								display: true,
								labelString: 'Маржинальная прибыль'
							}
						},
						{
							id: 'y-axis-2',
							type: 'linear',
							position: 'right',
							ticks: {
								beginAtZero: true,
								// Formatter for values in thousands
								callback: function(value) {
									return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
								}
							},
							scaleLabel: {
								display: true,
								labelString: 'Бонусы'
							}
						}
					],
					xAxes: [
						{
							ticks: {
								beginAtZero: true
							}
						}
					]
				},
				tooltips: {
					mode: 'index',
					position: 'average',
					intersect: false,
					callbacks: {
						// Custom tooltip formatter for each dataset
						label: function(tooltipItem, data) {
							let datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
							let value = tooltipItem.yLabel.toString();
							let formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
							return datasetLabel + ': ' + formattedValue;
						}
					}
				},
				maintainAspectRatio: false,
				responsive: true
				},
			height: 250,
		};
	},
	mounted() {
		this.fetchData();
	},
	methods: {
		fetchData() {
			this.loading = true;

			api.call('get', `${API_GET_MOTIVATION_LOAD_RESULTS_FOR_CHARTS}?date_from=${this.selectedPeriod}`)
				.then((response) => {
					this.processChartData(response.data);
					this.loading = false;
				});
			},
			processChartData(data) {
				let labels = [];
				let marginProfitData = [];
				let bonusPaymentsData = [];

				data.forEach((oneMonth) => {
					labels.push(oneMonth['date']);
					marginProfitData.push(Number(oneMonth['Маржинальная прибыль'].toFixed(2)));
					bonusPaymentsData.push(Number(oneMonth['Бонусы'].toFixed(2)));
				});

				// Set chartData for Line chart
				this.chartData = {
					type: 'Line',
					labels,  // Months for x-axis
					datasets: [
						{
							label: 'МП',
							borderColor: 'rgba(75, 192, 192, 1)',
							fill: false,
							data: marginProfitData,  // Values for "Маржинальная прибыль"
							yAxisID: 'y-axis-1',
						},
						{
							label: 'Бонусы',
							borderColor: 'rgba(255, 99, 132, 1)',
							fill: false,
							data: bonusPaymentsData,  // Values for "Бонусы"
							yAxisID: 'y-axis-2',
						}
					]
				};
			}			
		}
	};
</script>
